/* eslint-disable prefer-destructuring */
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { config } from "utils/config";
import { callApi } from "utils/utils";
import { Column } from "primereact/column";
import FieldDataTable from "components/Controls/FieldDataTable/FieldDataTable";
import { Skeleton } from "primereact/skeleton";
import moment from 'moment';
import FieldButton from "components/Controls/FieldButton/FieldButton";

const MiscellaneousQueries = (props) => {
  const { t } = useTranslation(["it", "common"]);
  const [queryResult, setQueryResult] = useState([]);
  const [columns, setColumns] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const gridExport = useRef(null);

  useEffect(() => {
    if(props.filters.EsBorrarInformacion){
      setQueryResult([]);
    }else if(props.filters.ClaConsultaGenerica>0){
      saveParams();
      }
  }, [props.filters]);


  const saveParams = async () => {
      const urlSaveParams = `${config.UrlApiProject}IT/SaveParams`;
      const paramsService = {
        ClaUbicacion:68,
        ClaConsultaGenerica:props.filters.ClaConsultaGenerica,
        IdTmpConsultaGenerica:props.filters.IdTmpConsultaGenerica,
        Params: props.filters.Params
      };
      setIsLoading(true);
      callApi(urlSaveParams, 'POST', paramsService, (response) => {
        const rawData = response.data.Result;
        if (rawData.length > 0) {
          const firstRow = rawData[0];
          const parsedColumns = Object.keys(firstRow).map((header) => parseColumnConfig(header));
          const transformedData = rawData.map((row) => transformRowData(row, parsedColumns));
          setColumns(parsedColumns);
          setQueryResult(transformedData);
        }
        setIsLoading(false);
      });
  };

  const parseColumnConfig = (columnStr) => {
    const [field, ...configs] = columnStr.split(";");
    const columnConfig = {
      originalField: columnStr,
      field: field.trim(),
      header: field.trim(),
      align: "left",
      width: "100px",
      type: "string",
      decimals: 0,
      visible: true,
      sum: false, 
    };

    configs.forEach((config) => {
      const [key, value] = config.split("=");
      switch (key.trim()) {
        case "a":
          columnConfig.align = value;
          break;
        case "w":
          columnConfig.width = `${value}px`;
          break;
        case "c":
          columnConfig.header = value;
          columnConfig.field = value;
          break;
        case "t":
          columnConfig.type = value.toLowerCase();
          break;
        case "d":
          columnConfig.decimals = parseInt(value, 10);
          break;
        case "v":
          columnConfig.visible = value === "true";
          break;
        case "s":
          columnConfig.sum = value === "sum"; 
          break;
        default:
          break;
      }
    });

    return columnConfig;
  };

  const transformRowData = (row, columns) => {
    const newRow = {};
    columns.forEach((col) => {
      newRow[col.field] = row[col.originalField];
    });
    return newRow;
  };

  const formatValue = (value, type, decimals) => {
    if (type === "moneda") {
      return value?.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: decimals });
    } 
    if (type === "decimal") {
      if (typeof value === "number" && !isNaN(value)) {
        return value.toFixed(decimals);
      } 
      return value;  
    }
    if (type === "date") {
      return value ? moment(value).format("MM/DD/YYYY") : '';
    }
    if (type === "porcentaje") {
      return `%${value}`;
    }
    const strValue = String(value).trim();
    const isDateWithTime = /\d{4}[-/]\d{2}[-/]\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?/.test(strValue);
    const isDateFormat = /^\d{4}[-/]\d{2}[-/]\d{2}$/.test(strValue);
    if (isDateWithTime) {
      const date = moment(strValue);
      return date.format("HH:mm:ss") === "00:00:00" 
        ? date.format("MM/DD/YYYY")  
        : date.format("MM/DD/YYYY HH:mm:ss");
    } 
    if (isDateFormat) {
      return moment(strValue).format("MM/DD/YYYY");
    }
    return <div className='overflow-ellipsis' title={value}>{value}</div>;
  };

  const calculateColumnSum = (field, type, decimals) => {
    const value = queryResult.reduce((sum, row) => sum + (parseFloat(row[field]) || 0), 0);
    if (type === "moneda" || type === "decimal") {
      return value.toLocaleString("en-US", { 
        style: "currency", 
        currency: "USD", 
        minimumFractionDigits: decimals 
      });
    } 
    return value;
  };

  const skeletonTemplate = () =>{
    return (<Skeleton height="1rem" width="100%" className="mb-2"></Skeleton>);
  }

  if (IsLoading){
    return (
      <>
        <FieldDataTable 
          value={[{},{},{},{},{},{},{},{}]}
          paginator={false}
        >     
          <Column header="&nbsp;" className='text-center' headerStyle={{ width: '50px' }} body={skeletonTemplate}></Column>
          <Column header="&nbsp;" className='text-center' headerStyle={{ width: '50px' }} body={skeletonTemplate}></Column>
          <Column header="&nbsp;" className='text-left' headerStyle={{ width: '100px' }} body={skeletonTemplate}></Column>
          <Column header="&nbsp;" className='text-left' headerStyle={{ width: '100px' }} body={skeletonTemplate}></Column>
          <Column header="&nbsp;" className='text-left' headerStyle={{ width: '100px' }} body={skeletonTemplate}></Column>
          <Column header="&nbsp;" className='text-left' headerStyle={{ width: '100px' }} body={skeletonTemplate}></Column>
          <Column header="&nbsp;" className='text-center' headerStyle={{ width: '50px' }} body={skeletonTemplate}></Column> 
        </FieldDataTable>
      </>
  );
  }

  const onExportGrid = () => {  
    gridExport.current.exportCSV();
 }

  
 return (
   <>
     {queryResult && queryResult.length > 0 ? (
       <>
         <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
           <FieldButton
             label={t('miscellaneousQueries:ExportToExcel')}
             className='p-button-info no-border p-mr-2'
             icon='pi pi pi-download'
             onClick={() => onExportGrid()}
           />
         </div>
         <FieldDataTable
           value={queryResult}
           scrollable
           scrollHeight="480px"
           footer
           refererence={gridExport}
         >
           {columns.map((col) =>
            col.visible ? (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                sortable={false}
                style={{ textAlign: col.align, width: col.width }}
                body={(rowData) => formatValue(rowData[col.field], col.type, col.decimals)}
                footer={col.sum ? calculateColumnSum(col.field, col.type, col.decimals) : null}
                footerStyle={{ textAlign: col.align, width: col.width, whiteSpace: "nowrap" }}
              />
            ) : null
          )}
         </FieldDataTable>
       </>
    ) : (
      <>&nbsp;</>
    )}
   </>
);

  
};

export default MiscellaneousQueries;